module.exports = __webpack_public_path__ + "img/blazon.9d7e2e67.png";